import { render } from "./v-link.vue?vue&type=template&id=8f09ff92"
import script from "./v-link.vue?vue&type=script&lang=js"
export * from "./v-link.vue?vue&type=script&lang=js"

import "./v-link.vue?vue&type=style&index=0&id=8f09ff92&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__